

function moneyFormat(Amount) {
  var formatter = Intl.NumberFormat('ja-JP');
  
  return formatter.format(Amount); /* $2,500.00 */
}

export default moneyFormat
